import React, { useEffect, useRef } from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import layout from "simple-keyboard-layouts/build/layouts/arabic";

interface ArabicKeyboardProps {
  value: string;
  setValue: (value: string) => void;
}

const ArabicKeyboard: React.FC<ArabicKeyboardProps> = ({ value, setValue }) => {
    return (  <Keyboard
        layout={layout.layout}
        layoutName="default"
        onChange={setValue}
        input={value}
      />
  );
};

export default ArabicKeyboard;
